export default "__VITE_ASSET__IV$KwOUM__"